import type { Firestore } from 'firebase/firestore/lite'
import { getFirebaseApp } from './firebaseApp'

let dbPromise: Promise<Firestore> | null = null

function getDb(): Promise<Firestore> {
  if (dbPromise) return dbPromise
  dbPromise = initDb()
  return dbPromise
}

async function initDb(): Promise<Firestore> {
  const app = await getFirebaseApp()
  const { getFirestore } = await import('firebase/firestore/lite')
  return getFirestore(app)
}

export async function fetchDocument<T>(collection: string, docId: string): Promise<T> {
  const db = await getDb()
  const { doc, getDoc } = await import('firebase/firestore/lite')
  const snapshot = await getDoc(doc(db, collection, docId))

  if (!snapshot.exists()) {
    throw new Error(`Firestore document not found: ${collection}/${docId}`)
  }

  return snapshot.data() as T
}

export async function fetchCollection<T>(collection: string): Promise<T[]> {
  const db = await getDb()
  const { collection: col, getDocs } = await import('firebase/firestore/lite')
  const snapshot = await getDocs(col(db, collection))

  return snapshot.docs.map(d => d.data() as T)
}

/** Reset for testing purposes only */
export function _resetFirestoreClient(): void {
  dbPromise = null
}
